import Vue from 'vue';
import axios from 'axios';
import { Auth } from '@aws-amplify/auth';
import router from '../router/index'
import i18n from '../i18n';

Vue.prototype.$adminApi = axios.create({
    baseURL: process.env.VUE_APP_ADMIN_API_BASE_URL
  });
  
Vue.prototype.$adminApi.interceptors.request.use(
    (config) => {
      return new Promise((resolve) => {
        config.headers['Accept-Language'] = i18n.locale;
        
        Auth.currentSession().then((session) => {
          if (session.getIdToken().getExpiration() < Math.round(+new Date() / 1000)) {
            Auth.currentAuthenticatedUser().then((user) => {
              user.refreshSession(session.getRefreshToken(), (error, data) => {
                if (error) {
                  Auth.signOut().then(() => {
                    router.push({ name: 'SignIn' });
                  });
                } else {
                  config.headers.Authorization = `Bearer ${data.getAccessToken().getJwtToken()}`;
                  resolve(config);
                }
              });
            });
          } else {
            config.headers.Authorization = `Bearer ${session.getAccessToken().getJwtToken()}`;
            resolve(config);
          }
        })
          .catch(() => {
            router.push({ name: 'SignIn' });
          });
      });
    }
  );

 const adminAPI = Vue.prototype.$adminApi
 export default adminAPI
